import { MaxBrainTag } from '../models/tag.model';

export class AddTags {
    static readonly type = '[Tag] AddTags';

    constructor(public payload: MaxBrainTag[]) {}
}
